import React from 'react'
import { Row, Col, Button, Progress, Spinner } from 'reactstrap'
import { ArrowRight, Table } from "phosphor-react"
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Lessons from '../../components/Study/Lessons.jsx'
import HomeWork from '../../components/Study/HomeWork.jsx'
import api from '../../api/api'
import { getPaginationInfo, isEmpty, processError } from '../../lib/lib'
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
import BlogEmulaton from '../../components/Study/BlogEmulation.jsx'
import SidebarEmulation from '../../components/Study/SidebarEmulation.jsx'
import HomeWorkModal from '../../components/Study/HomeWorkModal.jsx'
import File from '../../components/Study/File.jsx'
import styled from 'styled-components'
// import createHistory from 'history/createBrowserHistory'

// const history = createHistory({ forceRefresh: true })
const cookies = new Cookies()

const FilesWrapper = styled.div`
    .title {
        font-family: Open Sans;
        font-weight: 600;
        padding: 40px 0;
    }
`

const HomeWorkWrapper = styled.div`
    .title {
        font-family: Open Sans;
        font-weight: 600;
        padding-top: 40px;
    }
    .description {
        font-family: Open Sans;
        padding-top: 20px;
        color: #484848;
    }
`

class Study extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            limit: 2,
            catalog: [],
            course: {
                id: 0,
                themes: [],
                title: '',
            },
            status: {
                completed: 0,
                from: 0,
                percent: 0,
            },
            module: {
                id: 0,
                video: '',
                content: null,
                nextId: -1,
                taskFileDesc: '',
                taskFile: false,
                taskFiles: [],
                file: [],
            },
            pageTitle: null,
            pageLink: null,
            taskStatus: {
                comments: [
                    {
                        comment: "",
                        createdAt: "",
                        files: [],
                        from: "",
                        id: 0,
                        taskFileId: 0,
                        updatedAt: "",
                        userId: 0,
                    },
                ],
                courseId: 0,
                createdAt: "",
                id: 0,
                moduleId: 0,
                status: 0,
                success: false,
                teacherId: null,
                updatedAt: "",
                userId: 0,
            },
            table: {
                name: '',
                ratableTasks: [],
                unratableTasks: [],
            },
            allTable: {
                name: '',
                ratableTasks: [],
                rnratableTasks: [],
            },
            modalData: {
                name: '',
                ratableTasks: [],
                unratableTasks: [],
            },
            dataLoaded: false,
            courseLodaed: false,
            moduleLoaded: false,
            tryComplitionAction: false,
            complitionAction: false,
            modalShow: false,
            allTableLoaded: false,
            estimates: false,
        }
        this.routeToTest = this.routeToTest.bind(this)
        this.tryToComplete = this.tryToComplete.bind(this)
        this.getCourse = this.getCourse.bind(this)
        this.getCatalog = this.getCatalog.bind(this)
        this.completeModule = this.completeModule.bind(this)
        this.setModalShow = this.setModalShow.bind(this)
    }

    async tryToComplete(course, modId, nextId) {
        this.setState({ tryComplitionAction: true })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        if (nextId) {
            api.courseCompleteModule({ courseId: course.id, modId, data: {}, token, lang })
                .then(async ({ success }) => {
                    if (success) {
                        const module = await this.getModule({ courseId: course.id, modId: nextId, token, lang })
                        if (module.type === 'test') {
                            this.props.history.push(`/course/${this.props.match.params.courseId}/test/${nextId}`)
                        } else {
                            this.props.history.push(`/course/${this.props.match.params.courseId}/mod/${nextId}`)
                            document.location.reload()

                            // const pageLink = `МОЁ ОБУЧЕНИЕ / ${this.state.course.title} / ${module.title}`
                            // const pageTitle = `${module.title}. ${this.state.course.title}.`
                            // const { completed, from, uncompleted, percent } = await this.getCourseStatus(course)
                            // this.setState({ module, pageLink, pageTitle, status: { completed, from, percent, uncompleted } })
                        }
                        this.setState({ tryComplitionAction: false })
                    }
                })
                .catch((e) => processError(e, this.props.history))
        }
    }

    routeToTest() {
        this.props.history.push(`/course/${this.props.match.params.courseId}/test/${this.props.match.params.modId}`)
    }

    getCatalog(data) {
        return new Promise((resolve, reject) => {
            api.getCatalog(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getCourses(page, limit, lang, accessToken) {
        return new Promise((resolve, reject) => {
            api.getCourses(page, limit, lang, accessToken)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getThemes(id, token, lang) {
        return new Promise((resolve, reject) => {
            api.getCourseInfo(id, token, lang)
                .then((res) => resolve(res.themes))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getCourse(id, lang, token) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            try {
                // const courses = await this.getCourses(0, 500, lang, token)
                // const course = await courses.filter((course) => String(course.id) === String(id))[0]
                const course = await api.getCourseInfo(id, token, lang)
                resolve(course)
            } catch (e) {
                reject(e)
            }
        })
    }

    getModule(data) {
        return new Promise((resolve, reject) => {
            api.getModuleInfo(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getTaskStatus(data) {
        return new Promise((resolve, reject) => {
            api.getTaskStatus(data)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    getCourseStatus(course) {
        return new Promise((resolve) => {
            let completed, from, uncompleted, percent
            try {
                completed = ((course.themes.map((theme) => theme.modules.filter((mod) => mod.complete))).map((arr) => arr.length)).reduce((a, b) => a + b)
            } catch (e) {
                completed = 0
            }
            try {
                from = (course.themes.map((theme) => theme.modules.length)).reduce((a, b) => a + b)
            } catch (e) {
                from = 0
            }
            try {
                uncompleted = (course.themes.map((theme) => theme.modules.filter((mod) => !mod.complete))).reduce((a, b) => a.concat(b))
            } catch (e) {
                uncompleted = 0
            }
            percent = completed / from * 100
            resolve({ completed, from, percent, uncompleted })
        })
    }

    async updateHomework(data) {
        const taskStatus = await this.getTaskStatus(data)
        if (this.state.module.taskFiles.length) {
            let { taskFiles, ...rest } = this.state.module
            const order = JSON.parse(JSON.stringify(this.state.module.taskFiles))
            const updated = (taskFiles.map((item) => item.id === taskStatus.localId ? { id: item.id, taskStatus, title: item.title } : false)).filter((item) => item)
            const old = (taskFiles.map((item) => item.id !== taskStatus.localId ? item : false)).filter((item) => item)
            taskFiles = [...old, ...updated]
            taskFiles = order.map((item) => taskFiles.find((tItem) => item.id === tItem.id))
            this.setState({ taskStatus, module: { taskFiles, ...rest } })
        }
    }

    getModuleEstimates(course, modId) {
        return new Promise((resolve) => {
            const module = (course.themes.map((theme) => theme.modules.find((mod) => String(mod.id) === String(modId))).find((mod) => mod))
            module.estimate ? resolve({ tasks: module.estimate.tasks }) : resolve([])
        })
    }

    getCourseEstimates(course) {
        return new Promise((resolve) => {
            const estimates = course.themes.map((theme) => ({ title: theme.title, modules: theme.modules.filter((mod) => mod.estimate).map((mod) => ({ title: mod.title, estimate: mod.estimate })) }))
            !isEmpty(estimates) ? resolve(estimates) : resolve([])
        })
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const modId = this.props.match.params.modId
        const courseId = this.props.match.params.courseId
        const { end, start } = getPaginationInfo({ page: this.state.limit, limit: this.state.limit })
        const { t } = this.props

        let arrPromise = [
            this.getCourse(courseId, lang, token).then((course) => {
                this.setState({ course, courseLodaed: true })
                this.getCourseStatus(course).then(({ completed, from, uncompleted, percent }) => this.setState({ status: { completed, from, percent, uncompleted } }))
                this.getModule({ modId, courseId, token, lang }).then((module) => {
                    if (module.type === 'test') this.props.history.push(`/course/${courseId}/test/${modId}`)
                    const pageLink = `${t('study-my')} / ${course.title} / ${module.title}`
                    const pageTitle = `${module.title}. ${course.title}.`

                    const taskFiles = JSON.parse(module.taskFiles)
                    this.getCourseEstimates(course).then((allTable) => {
                        if (!isEmpty(allTable)) {
                            this.setState({ allTable, allTableLoaded: true })
                        }
                    })
                    if (!isEmpty(taskFiles)) {
                        const promises = []
                        taskFiles.forEach((taskFile, index) => {
                            promises.push(
                                new Promise((resolve) => {
                                    this.getTaskStatus({ localId: taskFile.id, courseId, modId, token, lang })
                                        .then((taskStatus) => {
                                            taskFiles[index].taskStatus = taskStatus
                                            resolve()
                                        })
                                }),
                            )
                        })
                        Promise.all(promises).then(() => {
                            module.taskFiles = taskFiles
                            this.getModuleEstimates(course, modId).then((table) => {
                                if (!isEmpty(table)) {
                                    const ratableTasks = table.tasks.filter((task) => task.ratable)
                                    const unratableTasks = table.tasks.filter((task) => !task.ratable)
                                    const totalScore = ratableTasks.length ? (ratableTasks.map((task) => Number(task.score))).reduce((a, b) => a + b) : 0
                                    const totalMaxScore = ratableTasks.length ? (ratableTasks.map((task) => Number(task.maxScore))).reduce((a, b) => a + b) : 0
                                    const percent = (Number(totalScore) / Number(totalMaxScore) * 100).toFixed(2)
                                    table = { ...table, totalScore, totalMaxScore, percent, ratableTasks, unratableTasks }
                                    this.setState({ table, pageLink, pageTitle, module, moduleLoaded: true })
                                }
                            })
                        })
                    } else {
                        module.taskFiles = []
                        this.setState({ pageLink, pageTitle, module, moduleLoaded: true })
                    }
                })
            }),
            this.getCatalog({ end, start, lang, token }).then(({ rows }) => {
                const sorted = rows.filter((item) => item.typeId === 2)
                this.setState({ catalog: sorted })
            }),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    completeModule() {
        this.setState({ complitionAction: true })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const modId = this.state.module.id
        const courseId = this.state.course.id
        api.courseCompleteModule({ courseId, modId, data: {}, token, lang })
            .then(async ({ success }) => {
                if (success) this.props.history.push(`/course/complete/${this.props.match.params.courseId}`)
                this.setState({ complitionAction: false })
            })
            .catch((e) => processError(e, this.props.history))
    }

    setModalShow(bool, modalData = null, estimates = false) {
        if (!bool) this.setState({
            modalData: {
                name: '',
                ratableTasks: [],
                unratableTasks: [],
            },
        })
        this.setState({ estimates }, () => {
            if (modalData) this.setState({ modalShow: bool, modalData })
            else this.setState({ modalShow: bool })
        })
    }

    render() {
        const { t } = this.props
        return (
            <React.Fragment>
                <HomeWorkModal
                    show={this.state.modalShow}
                    onHide={() => this.setModalShow(false)}
                    toggle={() => this.setModalShow(!this.state.modalShow)}
                    state={this.state.modalData}
                    props={this.props}
                    estimates={this.state.estimates}
                />

                <div className="content custom-bg position-relative">
                    <Row className="w-100 mx-0">
                        <Col xs={12} md={12} className="px-0">
                            <div className="page-title">
                                <div className="float-left w-100">
                                    {
                                        this.state.pageLink !== null ?
                                            <h1 className="title lesson-dashboard md-font-size">{this.state.pageLink}</h1>
                                            :
                                            <div className="ml-20px">
                                                <Skeleton className="title lesson-dashboard md-font-size" width={'80%'} />
                                            </div>
                                    }
                                </div>
                            </div>

                            <div className="col-xl-12">
                                <section>
                                    <div className="content-body news-bg position-relative">
                                        {' '}
                                        <div className="row w-100 mx-0">
                                            <div className="col-12 px-0">
                                                <div className="row">
                                                    <div className="col-xl-8">
                                                        <div className="col-12">
                                                            {
                                                                this.state.pageTitle !== null ?
                                                                    <div className="lesson-title xl-font-size">{this.state.pageTitle}</div>
                                                                    :
                                                                    <React.Fragment>
                                                                        <Skeleton className="lesson-title xl-font-size" style={{ paddingTop: 0, marginTop: '80px' }} />
                                                                    </React.Fragment>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-8">
                                                        <div className="col-12">
                                                            <div className="card lesson-card">
                                                                {
                                                                    this.state.moduleLoaded ?
                                                                        <React.Fragment>
                                                                            {
                                                                                this.state.module.video ?
                                                                                    this.state.module.video.includes('youtube.com') ?
                                                                                        <iframe
                                                                                            className={`${this.state.module.video && this.state.module.video.includes('youtube.com') ? '' : 'd-none'}`}
                                                                                            src={this.state.module.video}
                                                                                            width="100%"
                                                                                            height="400"
                                                                                            frameBorder="0"
                                                                                            allowFullScreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
                                                                                            title={this.state.module.video}
                                                                                        ></iframe>
                                                                                        :
                                                                                        this.state.module.video.includes('vimeo.com') ?
                                                                                            <iframe
                                                                                                className={`${this.state.module.video && this.state.module.video.includes('vimeo.com') ? '' : 'd-none'}`}
                                                                                                src={this.state.module.video}
                                                                                                width="100%"
                                                                                                height="400"
                                                                                                frameBorder="0"
                                                                                                allowFullScreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
                                                                                                title={this.state.module.video}
                                                                                            ></iframe>
                                                                                            : ''
                                                                                    : ''
                                                                            }
                                                                            <div className="lesson-text-wrapper" dangerouslySetInnerHTML={{ __html: this.state.module.content }}></div>
                                                                        </React.Fragment>
                                                                        :
                                                                        <BlogEmulaton />
                                                                }
                                                                {
                                                                    this.state.dataLoaded ?
                                                                        !isEmpty(this.state.module.file) ?
                                                                            <FilesWrapper>
                                                                                <div className="title lg-font-size primary">{t('study-files')}</div>
                                                                                <Row className='w-100 m-0'>
                                                                                    {
                                                                                        this.state.module.file.map((file, index) => {
                                                                                            return (
                                                                                                <File
                                                                                                    key={index}
                                                                                                    file={file}
                                                                                                    title={file}
                                                                                                />
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </Row>
                                                                            </FilesWrapper>
                                                                            :
                                                                            ''
                                                                        :
                                                                        <React.Fragment>
                                                                            <Skeleton width={'30%'} className="my-5 title lg-font-size primary" />
                                                                            <Row>
                                                                                <File skeleton={true} />
                                                                                <File skeleton={true} />
                                                                                <File skeleton={true} />
                                                                                <File skeleton={true} />
                                                                            </Row>
                                                                        </React.Fragment>
                                                                }
                                                                {
                                                                    this.state.dataLoaded ?
                                                                        !isEmpty(this.state.module.taskFiles) ?
                                                                            <HomeWorkWrapper>
                                                                                <div className="title lg-font-size primary">{t('homework')}</div>
                                                                                <div className="title lg-font-size primary">{t('homework-faq')}</div>
                                                                                {
                                                                                    this.state.module.taskFiles.map((taskFile) => {
                                                                                        return (
                                                                                            <HomeWork
                                                                                                key={taskFile.id}
                                                                                                courseId={this.props.match.params.courseId}
                                                                                                modId={this.props.match.params.modId}
                                                                                                localId={taskFile.id}
                                                                                                taskStatus={taskFile.taskStatus}
                                                                                                title={taskFile.title}
                                                                                                description={this.state.module.taskFileDesc}
                                                                                                updateHomework={() => this.updateHomework({
                                                                                                    localId: taskFile.id,
                                                                                                    courseId: this.props.match.params.courseId, modId: this.props.match.params.modId, token: cookies.get('accessToken'), lang: this.props.i18n.language,
                                                                                                })}
                                                                                            />

                                                                                        )
                                                                                    })
                                                                                }
                                                                            </HomeWorkWrapper>
                                                                            : ''
                                                                        : <HomeWork skeleton={true} />
                                                                }
                                                                <div className="lesson-btn-wrapper pt-0">
                                                                    {
                                                                        this.state.dataLoaded ?
                                                                            <React.Fragment>
                                                                                {
                                                                                    this.state.module.nextId ?
                                                                                        <Button
                                                                                            type="button"
                                                                                            className="btn profile-avatar-btn primary mr-40px p-10-20px"
                                                                                            disabled={(this.state.taskStatus.id && (String(this.state.taskStatus.status) !== '1' && this.state.module.taskFile)) || this.state.complitionAction}
                                                                                            onClick={() => this.tryToComplete(this.state.course, this.props.match.params.modId, this.state.module.nextId)}
                                                                                        >
                                                                                            <div className="d-flex align-items-center">
                                                                                                {this.state.tryComplitionAction ? <Spinner size="sm" /> : <ArrowRight size={20} />}
                                                                                                <span className="pl-5px sm-font-size">{t('study-next-module')}</span>
                                                                                            </div>
                                                                                        </Button> :
                                                                                        this.state.module.nextId === -1 ? '' :
                                                                                            <Button
                                                                                                type="button"
                                                                                                className="btn profile-avatar-btn primary mr-40px p-10-20px" onClick={this.completeModule}
                                                                                                disabled={(this.state.taskStatus.id && (String(this.state.taskStatus.status) !== '1' && this.state.module.taskFile)) || this.state.complitionAction}
                                                                                            >
                                                                                                <div className="d-flex align-items-center">
                                                                                                    {this.state.complitionAction ? <Spinner size="sm" /> : <ArrowRight size={20} />}
                                                                                                    <span className="pl-5px sm-font-size">{t('study-end-course')}</span>
                                                                                                </div>
                                                                                            </Button>
                                                                                }
                                                                                {
                                                                                    this.state.module.nextId && this.state.table.ratableTasks.length ?
                                                                                        <Button
                                                                                            type="button"
                                                                                            className="btn profile-avatar-btn primary p-10-20px"
                                                                                            onClick={() => this.setModalShow(true, this.state.table)}
                                                                                        >
                                                                                            <div className="d-flex align-items-center">
                                                                                                <Table size={20} />
                                                                                                <span className="pl-5px sm-font-size">{t('study-watch-result')}</span>
                                                                                            </div>
                                                                                        </Button>
                                                                                        : ''
                                                                                }
                                                                            </React.Fragment>
                                                                            :
                                                                            <Skeleton className="btn profile-avatar-btn primary mr-40px p-10-20px" width={'30%'} />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-4 lessons-bar-wrapper d-flex flex-column">
                                                        <div className="lessons-bar">
                                                            {
                                                                this.state.courseLodaed ?
                                                                    <React.Fragment>
                                                                        <div className="bar-title lg-font-size">{this.state.course.title}</div>
                                                                        <div className="bar-progress lg-font-size">{t('study-progress')} ({this.state.status.completed}/{this.state.status.from})</div>
                                                                        <Progress className="custom-progress" color="success" value={this.state.status.percent} />
                                                                        <div className="lesson-items">
                                                                            {this.state.course.themes.map((theme) => (
                                                                                <Lessons key={theme.id}
                                                                                    id={theme.id}
                                                                                    title={theme.title}
                                                                                    modules={theme.modules}
                                                                                    modId={Number(this.props.match.params.modId)}
                                                                                    courseId={this.props.match.params.courseId}
                                                                                    props={this.props}
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    </React.Fragment>
                                                                    :
                                                                    <SidebarEmulation />
                                                            }
                                                        </div>
                                                        {

                                                            this.state.allTableLoaded && !isEmpty(this.state.allTable) ?
                                                                <Button
                                                                    type="button"
                                                                    className="mt-3 btn profile-avatar-btn primary p-10-20px ml-auto"
                                                                    onClick={() => this.setModalShow(true, this.state.allTable, true)}
                                                                >
                                                                    <div className="d-flex align-items-center">
                                                                        <Table size={20} />
                                                                        <span className="pl-5px sm-font-size">{t('study-watch-result')}</span>
                                                                    </div>
                                                                </Button>
                                                                :
                                                                <Skeleton className="d-block w-50 ml-auto mt-3" style={{ height: '35px' }} />
                                                        }
                                                    </div>
                                                </div>
                                                {/* <div className="row">
                                                <div className="col-12">
                                                    <div className="col-12">
                                                        <PersonalRecommendation catalog={this.state.catalog} />
                                                    </div>
                                                </div>
                                            </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </Col >
                    </Row >
                </div >
            </React.Fragment>
        )
    }
}

Study.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(Study)



// WEBPACK FOOTER //
// ./src/views/Study/StudyDesc.jsx